import { ConditionValue } from '@mode-vegas/vegas';
import { DataType, DateTime } from '@mode-switch/express';
import { safeStringToBool, safeStringToNumber } from '@mode/shared/util-js';

// Typed filter helper
export function isConditionValue(value?: unknown): value is ConditionValue {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'string': {
      return true;
    }
    default: {
      return value === null;
    }
  }
}

/**
 * @description Given an array of primitives and a DataType, will return an array
 * of values (literals) that are switch compatible for filtering and sorting. For
 * Timestamps, we convert from Millis to the provided DataType's TimeUnit
 * @param values Array of primitives to map/filter
 * @param type DataType of the values to map/filter
 */
export function safeMapValues<T>(values: T[], type: DataType): ConditionValue[] {
  return values
    .map((value) => {
      if (isConditionValue(value)) {
        // Null values are valid in filters/sorts and must not be omitted
        if (value === null) {
          return value;
        }

        switch (type.name) {
          case DataType.Name.Boolean: {
            return safeStringToBool(value);
          }
          case DataType.Name.DateTime:
          case DataType.Name.Decimal:
          case DataType.Name.Integer:
          case DataType.Name.Float: {
            return safeStringToNumber(value);
          }
          case DataType.Name.Timestamp: {
            switch (type.unit) {
              case DateTime.TimeUnit.Micros: {
                return safeStringToNumber(value) * 1000;
              }
              case DateTime.TimeUnit.Second: {
                return safeStringToNumber(value) / 1000;
              }
              default: {
                return safeStringToNumber(value);
              }
            }
          }
          default: {
            return '' + value;
          }
        }
      }
    })
    .filter(isConditionValue);
}
